export var TitleSecondary = _ref => {
  var {
    headerColor
  } = _ref;
  return () => ({
    textStyle: headerColor == null ? {} : {
      color: headerColor.toString()
    }
  });
};
//# sourceMappingURL=TitleSecondary.js.map